package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SubjectResponse(
    @SerialName("school_id")
    val schoolId: String? = null,
    val name: String? = null,
    @SerialName("short_code")
    val shortCode: String? = null,
    val category: String? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    val id: String? = null,
    @SerialName("created_at")
    val createdAt: String? = null,
    @SerialName("updated_at")
    val updatedAt: String? = null,
    @SerialName("created_by_name")
    val createdByName: String? = null,
    @SerialName("created_by_id")
    val createdById: String? = null,
    @SerialName("updated_by_name")
    val updatedByName: String? = null,
    @SerialName("updated_by_id")
    val updatedById: String? = null
)
